























































import {
  uploadFileApi,
  deleteFileApi,
  downLoadStuFileApi,
  downLoadAllFileApi,
} from '@/api/index'
import TableComp from '@/components/Common/TableComp.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'studentAttachmentList',
  components: {
    TableComp,
  }
})
export default class extends Vue {
  @Prop() public tableData!: any;

  public loading: boolean = false;

  // 下载文件
  public async downloadFile(row: any) {
    if(this.loading) {
      return;
    }
    const downLoadData = {
      fileKey: row.issueTypeKey,
      fileNameOrc: row.fileNameOrc,
      filePath: row.filePath.substring(1),
    };
    this.loading = true;
    try {
      const res = await downLoadStuFileApi(downLoadData);
      if (res) {
        const blob = new Blob([res.data]);
        const elink = document.createElement("a");
        elink.download = downLoadData.fileNameOrc;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
        this.loading = false;
      }
    } catch(err) {
      this.loading = false
    }
  }

  public downLoadAllFile() {
    const stuid = this.$route.params.id + '';
    // 下载全部文件
    downLoadAllFileApi(stuid).then((res) => {
      if (res) {
        const blob = new Blob([res.data], { type: "application/zip" });
        const elink = document.createElement("a");
        elink.download = this.$t("stuManagement.studentInformation") as string;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      }
    });
  }

  public beforeUpload(file: any, row: any) {
    const typeKey = row.typeKey;
    const type = file.type.toLowerCase();
    if ((!(typeKey === 'PASSPORT') && type.indexOf("pdf") < 0) || (typeKey === 'PASSPORT' && (type.indexOf("image") < 0 && type.indexOf("pdf") < 0))) {
      this.$message.error(this.$t("message.uploadLimit") as string);
      return false;
    }
    const sizeLimit = row.sizeLimit || 2;
    if ((file.size / 1024 / 1024) > sizeLimit) {
      this.$message.error(this.$t("message.uploadSize",{limit: sizeLimit}) as string);
      return false;
    }
  }

  public addStudentAttachment() {
    const stuid = this.$route.params.id + '';
    const agentId = UserModule.fkAgentId;
    this.$router.push({ name: 'studentApplicationForm', params: { stuid }, query: { agid: agentId, activeNames: 'fileData' }});
  }

  // 上传文件
  public async uploadFile(data: any, row: any) {
    if (this.loading) {
      return;
    }
    this.loading = true;
    try {
      const formdata = new FormData();
      const studentId = this.$route.params.id as string;
      formdata.append(data.filename, data.file);
      formdata.append("type", 'ISSUE-CENTER');
      formdata.append("stuId", studentId);
      formdata.append('typeKey', row.issueTypeKey);
      formdata.append("oldFkGuId", row.fileGuid)
      if (row.issueTypeKey === 'PS') {
        formdata.append("fkInstitutionCourseName", row.fkInstitutionCourseName);
        formdata.append("fkInstitutionName", row.fkInstitutionName);
        formdata.append("fkInstitutionShortName", row.fkInstitutionShortName);
        formdata.append("fkCourseId", row.fkStudentInstitutionCourseId);
      }
      const res = await uploadFileApi(formdata);    // 上传文件
      this.loading = false;
      if (!res.data || res.data.code !== '1003') {
        const message = res.data.message || this.$t("message.uploadFail");
        this.$message({
          message,
          type: "error",
        });
        return;
      }
      this.$emit('update-list');
    } catch(err) {
      this.loading = false;
      this.$message({
        message: this.$t("message.updateFail") as string,
        type: "error",
      });
    }
  }

  // 保持只上传一个
  public changeFile(fileList: any) {
    if (fileList && fileList.length > 1) {
      fileList.splice(0, 1);
    }
  }

  // 删除文件
  public async deleteFile(row: any) {
    if(this.loading) {
      return;
    }
    const fkGuId = row.fileGuid;
    try {
      await this.$confirm(this.$t("message.delMsgFile") as string, "", {
        confirmButtonText: this.$t("common.confirm") as string,
        cancelButtonText: this.$t("common.cancel") as string,
        type: "warning",
      })
      this.loading = true;
      const res = await deleteFileApi(fkGuId);
      this.loading = false;
      if (res.data && res.data.code === '1003') {
        this.$message({
          message: this.$t("message.deleteSucc") as string,
          type: "success",
        });
        this.$emit('update-list');
      } else {
        this.$message({
          message: this.$t("message.deleteFail") as string,
          type: "error",
        });
      }
    } catch (e) {
      this.loading = false;
      if(e === 'cancel') {
        return;
      }
      this.$message({
        message: this.$t("message.deleteFail") as string,
        type: "error",
      });
    }
  }
}
